import './style.sass';
import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import Image from 'next/image';

type DescriptionItem = {
    number?: string;
    name?: string;
    details?: string;
};

type MatrixeItem = {
    title: string;
    subtitle: string;
    description: DescriptionItem[];
    icon: string;
};

type LayoutPageProps = {
    listMatrixe: MatrixeItem[];
};

const Model = ({ listMatrixe }: LayoutPageProps) => {
    return (
        <div className="skills-solution">
            <FullWrapper>
                <div className="skills-solutionWrapper">
                    <div className="skills-solutionTitle">Ролевая модель</div>
                    <div className="skills-solutionInner">
                        <div className="skills-solutionLeft">
                            <div className="skills-solutionDescription">
                                В&nbsp;SkillsTeam используется ролевая модель: сотрудник, наставник
                                и&nbsp;администратор.
                            </div>
                            <div className="skills-solutionDescription">
                                Наставник принимает скилы, верифицирует уровень знаний, помогает
                                сотрудникам быстрее освоить необходимые навыки и&nbsp;избежать
                                распространенных ошибок.
                            </div>
                            <div className="skills-solutionDescription">
                                Руководитель управляет структурой команд и&nbsp;содержанием
                                библиотеки грейдов, отслеживает статистику по&nbsp;каждому
                                сотруднику и&nbsp;наставнику, обеспечивает стратегическое
                                руководство.
                            </div>
                            <div className="skills-solutionDescription">
                                У&nbsp;каждого сотрудника есть личный кабинет, где он&nbsp;видит
                                свой индивидуальный план развития, скилы для перехода
                                на&nbsp;следующий грейд, канбан-доску запланированных задач,
                                календарь встреч с&nbsp;наставником.
                            </div>
                            <div className="skills-solutionDescription">
                                На&nbsp;данный момент разработаны{' '}
                                <a
                                    className="aimed-layout-pageLink"
                                    href="https://skillsteam.pro/catalog"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    матрицы-компетенции
                                </a>{' '}
                                по&nbsp;ключевым направлениям в&nbsp;ИТ. Они доступны для
                                бесплатного скачивания для автоматизации ваших процессов.
                            </div>
                        </div>
                        <div className="skills-solutionRight">
                            <div className="skills-solutionRightText">
                                Система обеспечивает постоянный доступ к&nbsp;информации
                                о&nbsp;навыках сотрудников и&nbsp;аналитике.
                            </div>
                            <div className="skills-solutionRightPlay">
                                <Image
                                    src="/images/pic/skills-team/play.svg"
                                    alt="play"
                                    width={24}
                                    height={28}
                                />
                                <a
                                    className="skills-solutionRightLink"
                                    href="https://kinescope.io/5UrDyDWMvdSWzWsFFrjYSL"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Как это помогает в&nbsp;планировании карьерных траекторий
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <div className="skills-solutionMatrix">
                <FullWrapper isMargin={false}>
                    <div className="skills-solutionWrapper">
                        <div className="skills-solutionMatrixBlock">
                            <div className="skills-solutionMatrixContent">
                                <div className="skills-solutionMatrixMainTitle">
                                    Матрицы компетенций
                                </div>
                            </div>
                            <div className="skills-solutionMatrixList">
                                {listMatrixe.map((item, index) => (
                                    <div className="skills-solutionMatrixItem" key={index}>
                                        <div className="skills-solutionMatrixContent">
                                            <div className="skills-solutionMatrixTitle">
                                                {item.title}
                                            </div>
                                            <div className="skills-solutionMatrixSubtitle">
                                                {item.subtitle}
                                            </div>
                                            <div className="skills-solutionMatrixDescription">
                                                {item.description.map((desc, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="skills-solutionMatrixSkills"
                                                    >
                                                        {desc.number && (
                                                            <div className="skills-solutionMatrixNumber">
                                                                {desc.number}{' '}
                                                            </div>
                                                        )}
                                                        {desc.name && (
                                                            <div
                                                                className="skills-solutionMatrixName"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: desc.name,
                                                                }}
                                                            ></div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <Image
                                            src={item.icon}
                                            alt={item.title}
                                            width={161}
                                            height={161}
                                            className="skills-solutionMatrixIcon"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
            <div className="skills-solutionSistems">
                <FullWrapper isMargin={false}>
                    <div className="skills-solutionWrapper">
                        <div className="skills-solutionInner">
                            <div className="skills-solutionLeft">
                                <div className="skills-solutionDescription">
                                    Наша система адаптируется под любые команды и&nbsp;компании,
                                    позволяя настраивать матрицы под конкретные требования
                                    и&nbsp;задачи бизнеса. Техлиды и&nbsp;руководители могут легко
                                    использовать её&nbsp;для аттестаций, онбординга, построения
                                    индивидуальных планов развития и&nbsp;расширения компетенций
                                    сотрудников. Это актуально для ИТ-сферы, где скорость изменения
                                    высокая, и&nbsp;компании должны оставаться конкурентоспособными,
                                    быстро адаптируясь к&nbsp;новым условиям.
                                </div>
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
            <div className="skills-solutionProcess">
                <FullWrapper isMargin={false}>
                    <div className="skills-solutionWrapper">
                        <div className="skills-solutionProcessBlock">
                            <div className="skills-solutionProcessContent">
                                <div className="skills-solutionProcessMainTitle">
                                    Процесс работы
                                </div>
                                <div className="skills-solutionItem">
                                    <Image
                                        src="/images/svg/skills-team/p1.svg"
                                        alt="cloud system"
                                        width={1402}
                                        height={636}
                                        className="skills-solutionImg"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
        </div>
    );
};

export default Model;
